/**
 * Pre-booking commission fare rows for eligible B2B agents.
 * Checkout always debits full `amountToPay`; commission is credited later.
 */

/**
 * @param {{
 *   amountToPay: number,
 *   commissionPreview?: Record<string, unknown>|null,
 * }} args
 */
export function deriveCommissionFare({ amountToPay, commissionPreview }) {
  const pay = Number(amountToPay) || 0;
  if (!commissionPreview?.show_commission_lines) {
    return {
      showAgentLines: false,
      amountToPay: pay,
      chargeAmount: pay,
      showAmountToPayLabel: false,
    };
  }
  const commissionReceivable = Number(commissionPreview.agent_commission_gross) || 0;
  const tds = Number(commissionPreview.agent_tds_amount) || 0;
  const commissionNet = commissionReceivable - tds;
  const effectiveCost = pay - commissionNet;
  return {
    showAgentLines: true,
    showAmountToPayLabel: true,
    amountToPay: pay,
    chargeAmount: pay,
    commissionReceivable,
    tds,
    commissionNet,
    effectiveCost,
    isEstimate: commissionPreview.is_estimate !== false,
    nfAvailable: Boolean(commissionPreview.nf_available),
  };
}

/**
 * @param {Record<string, unknown>|null|undefined} reviewResponse
 * @param {Record<string, unknown>|null|undefined} bookingData
 * @param {Record<string, unknown>|null|undefined} [agent]
 */
export function resolveCommissionPreview(reviewResponse, bookingData, agent) {
  if (bookingData?.commissionPreview) {
    return bookingData.commissionPreview;
  }
  if (reviewResponse?.commission_preview) {
    return reviewResponse.commission_preview;
  }
  if (reviewResponse?.commissionPreview) {
    return reviewResponse.commissionPreview;
  }
  if (agent?.commission_eligible) {
    return {
      show_commission_lines: true,
      agent_commission_gross: 0,
      agent_tds_amount: 0,
      nf_available: false,
      is_estimate: true,
    };
  }
  return null;
}
